 
import {MdWebAsset,MdOutlineIntegrationInstructions,MdMobileFriendly } from "react-icons/md"
import {AiTwotoneShop} from "react-icons/ai"
import {SiGoogleoptimize} from "react-icons/si"
import {FaCogs} from "react-icons/fa"


export default [
    {
        title: 'Web Custom Application',
        desc: 'A unique website designed to suit your brand, product or company, depending on your business needs.',
        icon: <MdWebAsset/>
    },
    {
        title: 'Web Maintenance',
        desc: 'Ensure that you get an immediate consultation and solution to any problems you might have with your website.',
        icon: <FaCogs/>
    },
    {
        title: 'Responsive Design',
        desc: 'Make the website user-friendly and make it work on a variety of devices and sizes of windows.',
        icon: <MdMobileFriendly/>
    },
    {
        title: 'Web Optimization',
        desc: 'Optimize both the functionality and design to minimize load times and make your website load quickly.',
        icon: <SiGoogleoptimize/>
    },
    {
        title: 'E-commerce Development',
        desc: 'Integrating E-commerce web development powered by Woocommerce so that you can have an online store.',
        icon: <AiTwotoneShop/>
    },
    {
        title: 'Third party integration',
        desc: 'Allow easy and secure integration of well-established third-party apps, such as Calendly, Infusionsoft, Google Analytics, etc.',
        icon: <MdOutlineIntegrationInstructions/>
    },
    
     
]